<template lang="html">
  <div style="height: 100%;">
    <div class="button-wrap toolbar" style="position:absolute; padding:20px; z-index:9999;">
      <button type="button" class="btn btn-default btn-" @click="exportCounter">
        <span class="btn-icon">
          <i class="iconfont icon-export"></i>
        </span>
        导出小区抄表信息
      </button>
  </div>
    <DataTablePage ref="historyTable"
    mainColumn=""
    longColumn=""
    title="用水历史"
    label="用水"
    labelName=""
    :resource="resource"
    :toolbar="customerId == 1 ? toolbar_manager : toolbar_customer"
    :operation="customerId == 1 ? operation_manager : operation_customer"
    :operationWidth="customerId == 1 ? 105 : 75"
    :updateList="updateList"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns"
    @getData="getCountInitStatus"
    @checkGroupValue="checkGroupValue"></DataTablePage>
  </div>
  <!-- DataTablePage(
    ref="historyTable"
    mainColumn=""
    longColumn=""
    title="用水历史"
    label="用水"
    labelName=""
    :resource="resource"
    :toolbar="customerId == 1 ? toolbar_manager : toolbar_customer"
    :operation="customerId == 1 ? operation_manager : operation_customer"
    :operationWidth="customerId == 1 ? 105 : 75"
    :updateList="updateList"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns"
    @getData="getCountInitStatus"
    @checkGroupValue="checkGroupValue") -->
</template>
<script>
import axios from 'axios'
import DataTablePage from '@/containers/DataTablePage'
import columns from './waterColumns.js'
import { operationUpdate } from '@/containers/DataTablePage/operation'
import { fetchBatch, fetchItem, fetchUpdate, fetch } from '@/utils/api'
import { map } from 'lodash'
import { expire, getCustomerId } from '@/utils/auth'
export default {
  name: 'WaterList',
  components: {
    DataTablePage
  },
  data () {
    return {
      customerId: getCustomerId(),
      toolbar_manager: [{
        label: '批量回填',
        funcProps: {
          el: this
        },
        func ({funcProps}) {
          const { el } = funcProps
          const counterId = el.findCounterId(el.checkGroup)
          if (!counterId.length) {
            this.$swal('错误', '请选择需要批量回填数据', 'info')
            return
          }
          fetchBatch({
            url: '/nb/data/batchBackfill',
            ids: counterId
          }).then(res => {
            if (res) {
              this.$swal('批量回填成功', '', 'success')
            }
            el.refreshTable()
          })
        }
      }],
      toolbar_customer: [],
      /**
      * 操作按钮
      */
      operation_manager: [{
        ...operationUpdate,
        isShow (data) {
          return !data.backfillStatus
        }
      }, {
        label: '回填数据',
        icon: 'refresh',
        tooltip: true,
        funcProps: {
          el: this
        },
        isShow (data) {
          return !data.backfillStatus
        },
        func ({funcProps}) {
          const { data, el } = funcProps
          el.setDataBack(data.counterId, (data) => {
            this.disabled = Boolean(data)
            this.buttonType = data ? 'success' : 'error'
            this.buttonLabel = data ? '回填成功' : '回填失败'
            if (data) this.$swal('回填成功', '', 'success')
          })
        }
      }],
      /**
      * 操作按钮
      */
      operation_customer: [{
        ...operationUpdate,
        isShow (data) {
          return !data.backfillStatus
        }
      }],
      copyTableData: [], // table列表数据
      checkGroup: [], // 勾选的数组
      /**
      * 点抄参数
      **/
      readingstatus: 'ready',
      statusType: 'success',
      statusText: '点抄', // 点抄按钮名称
      counterId: 0,
      resource: '/nb/history/base',
      tableFullList: ['checkBox', 'hno', 'counterCode', 'period', 'num', 'image', 'quanty', 'quantyMonth', 'hname', 'addr', 'cost', 'wave', 'phone', 'mobile'],
      tableInitList: ['checkBox', 'hno', 'counterCode', 'period', 'num', 'image', 'quanty', 'quantyMonth', 'hname', 'addr', 'phone', 'mobile'],
      filterFullList: ['areaId', 'period'],
      filterInitList: ['areaId', 'period'],
      updateList: ['num'],
      columns: {
        ...columns,
        hno: {
          label: '户号',
          type: 'input',
          // link: true,
          // link: `/telnetReading/history?counterId=${this.$refs.historyTable.counterId}`,
          width: 110,
          form: {
            type: 'input',
            size: 10,
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          },
          filter: {
            type: 'input',
            width: 100,
            like: true
          }
        },
        image: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${data}" style="height:24px"></img>`
          }
        },
        readingStatus: {
          label: '点抄状态',
          type: 'select',
          width: 100,
          options: [{
            label: '允许点抄',
            value: 'ready'
          }, {
            label: '正在点抄',
            value: 'processing'
          }, {
            label: '点抄失败',
            value: 'failed'
          }, {
            label: '点抄成功',
            value: 'finish'
          }]
        },
        quanty: {
          label: '日用水量',
          width: 100,
          style: {
            textAlign: 'center'
          }
        },
        quantyMonth: {
          label: '本月用水量',
          width: 100,
          style: {
            textAlign: 'center'
          }
        }
      },
      /**
       * 第几次监听进行中的任务，用于防止重复监听
      */
      listenProgressTimes: 0,
      /**
      * 当前点抄id数组
      */
      readingIdsGroup: [],
      processingNum: 0
    }
  },
  watch: {
    statusType (status) {
      this.renderRecord(status)
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.renderRecord('processing')
  },
  methods: {
    /* 点抄-- 根据后台返回的status状态改变，只有processing会每隔3秒轮询点抄接口
      初始页面根据列表接口返回的status，如果为finsh或ready，需要再次调用点抄接口查询到状态
      如果为processing时，则进行轮询
      @statusText 按钮名称，显示当前状态
      @isClick 判断是点击点抄，则为true，是轮询，false
    */
    // 初始化时获取点抄状态
    getCountInitStatus (data) {
      this.copyTableData = data.data
      const readingIdsGroup = data.data.filter(item => { return item.readingStatus === 'processing' })
      // const finishIdsGroup = data.data.filter(item => { return item.readingStatus === 'finish' })
      if (readingIdsGroup.length) {
        // 状态为processing，继续轮询点抄
        const readingIds = map(readingIdsGroup, 'counterId')
        // this.readingIdsGroup = readingIds
        console.info('get::', readingIds)
        this.requireReading(readingIds)
      }
      // else if (finishIdsGroup.length) {
      //   // 点抄成功需要再调点抄接口，转为ready......
      //   const finishIds = map(finishIdsGroup, 'counterId')
      //   console.info('get--finish::', finishIds)
      //   finishIdsGroup.map(item => {
      //     setTimeout(() => {
      //       this.requireSingleReading(item.counterId, finishIdsGroup.length, true)
      //     }, 500)
      //   })
      // }
    },
    renderProcessData () {
    },
    findCounterId (datas) {
      return datas.map(data => {
        return this.copyTableData.find(res => {
          return res.id === data
        }).counterId
      })
    },
    // 刷新table
    refreshTable () {
      this.$refs.historyTable.getData()
    },
    /*
    *返回点抄状态
    */
    renderRecord (status) {
      const statusText = status === 'processing' ? '点抄中'
            : status === 'failed' ? '点抄失败'
            : status === 'finish' ? '点抄完成'
            : '点抄' // 按钮显示的内容
      const statusType = status === 'processing' ? 'info'
            : status === 'failed' ? 'danger'
            : status === 'finish' ? 'success'
            : 'default' // 按钮显示类型
      this.statusText = statusText
      this.readingstatus = status
      this.statusType = statusType
      // console.info('点抄状态: ', statusType, statusText, status)
    },
    /**
    * 单个点抄,根据数组轮询，存放id于数组，点抄成功则移除该id
    **/
    handleSingleReading (id) {
      if (this.readingIdsGroup.indexOf(id) === -1) {
        this.readingIdsGroup.push(id)
      }
      const groupLen = this.readingIdsGroup.length
      // this.listenProgressTimes = groupLen
      this.requireSingleReading(id, groupLen)
    },
    /* 单个请求点抄 */
    requireSingleReading (id, times, isInit = false) {
      fetchItem({
        resource: '/nb/data/totalDataCopy',
        id: id
      }).then(data => {
        if (data.status === 'processing') {
          console.info('this.readingIdsGroup:', this.readingIdsGroup, times)
          this.listenReadingStatus(this.readingIdsGroup, this.listenProgressTimes + 1)
        } else {
          this.refreshTable()
        }
      })
    },
    /**
    * 点抄请求发起，批量操作
    * @ids  执行操作id   Array
    * @time 当前执行数量 number
    **/
    requireReading (ids) {
      if (!ids.length) {
        this.$swal('错误', '请选择需要批量点抄数据', 'info')
        return
      }
      fetchBatch({
        url: '/nb/data/batchReading',
        ids: ids
      }).then(res => {
        this.listenReadingStatus(ids, this.listenProgressTimes + 1)
      })
    },
    /**
    * 监听请求点抄状态
    **/
    listenReadingStatus (ids, times) {
      console.info('listen-status::', ids, this.listenProgressTimes, times)
      // 判断是不是新的监听，是的话更改监听次数
      if (this.listenProgressTimes < times) {
        this.listenProgressTimes = times
      }
      // 判断当前监听是不是最新监听，是的话才执行请求
      if (this.listenProgressTimes === times) {
        fetch({
          url: '/nb/data/batchReadingStatus',
          params: {
            ids: ids.join(',')
          }
        }).then(data => {
          if (data) {
            // 当前是否还有未点抄完成的，有则继续
            if (data.processingNum) {
              const that = this
              const processStatus = data.datas.filter(item => { return item.status === 'processing' })
              const processingIds = processStatus.map(res => {
                return res.counterId
              })
              // that.renderRecord(processStatus)
              that.progressListener = setTimeout(function () {
                that.listenReadingStatus(processingIds, times)
              }, 5000)
            }
            // 有已停止点抄的或不需要继续点抄
            if (this.processingNum !== data.processingNum || data.processingNum === 0) {
              this.processingNum = data.processingNum
              this.refreshTable()
            }
          }
        })
      }
    },
    /*
    *完成后init点抄状态
    */
    // initReadingStatus (ids) {
    //   console.info('ids:', ids)
    //   fetchItem({
    //     resource: '/nb/data/totalDataCopy',
    //     id: id
    //   }).then(data => {
    //     if (data) {
    //       this.refreshTable()
    //     }
    //   })
    // },
    /**
    * 数据回填
    **/
    setDataBack (countId, callback) {
      fetchUpdate({
        resource: `/nb/data/totalDataBackfill`,
        id: countId
      }).then(data => {
        callback ? callback(data) : null
      })
    },
    /**
    * 多选
    */
    checkGroupValue (value) {
      this.checkGroup = value
    },
    renderTableData (data) {
      this.copyTableData = data.data
    },
    exportCounter () {
      console.log('开始导出小区抄表信息')
      // 导出计量设备
      fetch({
        url: '/nb/history/export',
        params: {
          exportDataType: 'ExportDataTypeSubdistrictReading'
        }
      }).then(data => {
        console.log(data)
        if (data) {
          if (data.id === 0) {
            this.intervalId = setInterval(this.checkExportProcess, 1000)
          } else {
            this.$swal(data.message, '', 'warn')
          }
        } else {
          this.$swal('导出失败!', '', 'error')
        }
      })
      console.log('结束导出计量设备')
    },
    checkExportProcess () {
      fetch({
        url: '/nb/history/exportCheck',
        params: {
          exportDataType: 'ExportDataTypeSubdistrictReading'
        }
      }).then(data => {
        console.log(data)
        if (data) {
          console.log(data.message + ',' + data.id)
          if (data.id !== 6) {
            const status = data.id === 0 ? 'success' : 'warn'
            this.$swal(data.message, '', status)
            clearInterval(this.intervalId)
            if (status === 'success') {
              axios({
                method: 'POST',
                url: '/nb/wus/download?exportDataType=ExportDataTypeSubdistrictReading',
                data: {},
                responseType: 'arraybuffer'
              }).then(response => {
                console.log(response)
                if (!response) {
                  return
                }
                let contentDispostion = response.headers['content-disposition'].split(';')[1]
                let fileName = decodeURIComponent(contentDispostion.split('=')[1])
                console.log(contentDispostion)
                let url = window.URL.createObjectURL(new Blob([response.data]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
              }).catch(error => {
                console.log(error)
              })
            }
          }
        } else {
          clearInterval(this.intervalId)
          this.$swal('导出失败!', '', 'error')
        }
      })
    }
  },
  destroyed () {
    // clearTimeout(this.progressListener)
  }
}
</script>



// WEBPACK FOOTER //
// WaterList.vue?3266b865